var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.571.438H1.424C.638.438 0 1.085 0 1.879v17.116c0 .795.638 1.442 1.424 1.442h17.147c.786 0 1.429-.647 1.429-1.442V1.88c0-.794-.643-1.442-1.429-1.442zM6.045 17.58H3.08V8.036h2.97v9.544h-.005zM4.563 6.732a1.72 1.72 0 0 1 0-3.437c.946 0 1.718.772 1.718 1.718 0 .951-.768 1.72-1.718 1.72zM17.155 17.58h-2.964v-4.642c0-1.108-.022-2.532-1.54-2.532-1.545 0-1.781 1.206-1.781 2.451v4.723H7.905V8.036h2.844v1.303h.04c.398-.75 1.366-1.54 2.808-1.54 3 0 3.558 1.978 3.558 4.55v5.231z",
    fill: "#EAEAEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0f85c80c42ab6504fa957890e70ee9ba.svg";
export { ForwardRef as ReactComponent };